import { createSlice } from "@reduxjs/toolkit"
let data = { user: "jngissah" }

if (localStorage.getItem("user_sis") !== null && localStorage.getItem("user_sis") !== undefined && localStorage.getItem("user_sis") !== "") {
    data = JSON.parse(localStorage.getItem("user_sis"))
}

const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        login: (state, action) => {
            // Update state with the login data
            Object.assign(state, action.payload.data);
            // Remove the window.location.reload() as it's not needed with proper state management
        }


    },

})

export const { login } = Insider.actions;
export default Insider.reducer;